module.exports = __webpack_public_path__ + "img/zoom.9d516e9b.png";